import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { z } from "zod";

/**
 * A hook to set general zod error messages
 * If a new message is given in a Schema, it will override the general one
 */
export const useZodErrorMap = () => {
	const t = useTranslations("forms.errors.general");

	useEffect(() => {
		z.config({
			customError: (issue) => {
				switch (issue.code) {
					case "invalid_type":
						return t("required");
					case "too_small":
						return t("too_small");
					case "too_big":
						return t("too_big");
					default:
						return undefined;
				}
			},
		});
	}, [t]);
};
